module.exports = __webpack_public_path__ + "img/collect_empty.c8a65c7b.png";